import React from 'react';
import ParagraphContent from './ParagraphContent';
import ImageContent from './ImageContent';
import VideoContent from './VideoContent';
import ButtonContent from './ButtonContent';

const ContentRenderer = ({ 
    item, 
    index, 
    sectionTextColor, 
    nextItem, 
    isMobile,
    videoStates,
    handleVideoClick,
    handleVideoPlay,
    handleVideoPause,
    handleButtonClick,
    handleExternalLink,
    handleCopyClick
}) => {
    //console.log("ContentRenderer item:", item, "index:", index, "sectionTextColor:", sectionTextColor, "nextItem:", nextItem);
    switch (item.type) {
        case 'paragraph':
            return (
                <ParagraphContent 
                    item={item}
                    index={index}
                    sectionTextColor={sectionTextColor}
                />
            );

        case 'image':
            return (
                <ImageContent 
                    item={item}
                    index={index}
                    isMobile={isMobile}
                />
            );

        case 'video':
            return (
                <VideoContent 
                    item={item}
                    index={index}
                    isMobile={isMobile}
                    videoStates={videoStates}
                    handleVideoClick={handleVideoClick}
                    handleVideoPlay={handleVideoPlay}
                    handleVideoPause={handleVideoPause}
                />
            );

        case 'button':
            return (
                <ButtonContent 
                    item={item}
                    index={index}
                    nextItem={nextItem}
                    handleButtonClick={handleButtonClick}
                    handleExternalLink={handleExternalLink}
                    handleCopyClick={handleCopyClick}
                />
            );

        default:
            return null;
    }
};

export default ContentRenderer;